

export class ExpenseFilters {

  public staticFilters;
  public optionalFilters;

  constructor(private entities){


    this.staticFilters = [
      {
        entity: this.entities.expense.entity,
        field: {
          name: 'code',
          type: 'text',
          label: 'Código',
          width: 3
        }
      },
      {
        entity: this.entities.expense.entity,
        field: {
          name: 'concept',
          type: 'text',
          label: 'Concepto',
          width: 3
        }
      },
      {
        entity: this.entities.expense.entity,
        field: {
          name: 'type_state_id',
          type: 'select',
          label: 'Situación',
          width: 2,
          options: [
            {
              value:  -1,
              text: 'Todas'
            },
            {
              value:  1,
              text: 'Pendiente'
            },
            {
              value:  2,
              text: 'Semipagado'
            },
            {
              value:  3,
              text: 'Pagado'
            }
          ]
        }
      },
      {
        entity: this.entities.expense.entity,
        field: {
          name: 'created_at',
          type: 'date',
          label: 'Creado',
          width: 2,
          from: true
        }
      },
    ]


  }
}


